import React, { useState, useCallback, useEffect } from "react";
import { Grid, Stack } from "@mui/material";
import { useStyles } from "./styles";
import {
    Box,
    Button,
    Checkbox,
    MenuItem,
    Paper,
    Select,
    Table,
    InputAdornment,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { yearList } from "./fillter"
import CustomExpandMore from "../../../common/CustomExpandMore";
import Loader from "../../../common/Loader";
import useCourse from "../../../Hooks/course";
import useCircular from "../../../Hooks/circular";
import useAuthStore from "../../../Hooks/auth";
import CustomPagination from "../../../common/Pagination";

const columns = [
    {
        id: "register",
        label: "Register No",
        align: "center",
        sortby: true,
    },
    {
        id: "student",
        sortby: true,
        label: "Student Name",
        align: "center",
    },
    {
        id: "batch",
        sortby: true,
        label: "Batch",
        align: "center",
    },
    {
        id: "year",
        label: "Year",
        align: "center",
        sortby: true,
    },
];

const Migration = () => {
    const classes = useStyles();
    const { institutionId } = useAuthStore();
    const [state, setState] = useState([]);
    const [idStudent, setIdStudent] = useState({ studentIDS: [] });
    const [studentName, setStudentName] = useState([]);
    const [idDepartment, setIdDepartment] = useState("");
    const [idBatch, setIdBatch] = useState("");
    const [idYear, setIdYear] = useState("");
    const [formErrors, setFormErrors] = useState({});
    const [idDepartmentTable, setIdDepartmentTable] = useState("");
    const [idBatchTable, setIdBatchTable] = useState("");
    const [studentSearch, setStudentSearch] = useState("");
    const [page, setPage] = useState(1);
    const [PerPage, setPerPage] = useState(10);
    const [offset, setOffset] = useState(0);

    const {
        loading,
        getBatchByDepartmentIDAction,
        getStudentsByBatchAction,
        updateCurrentYearAction,
        getBatchByDepartment,
        getStudentsByBatch,
        updateCurrentYearData,
        searchStudentForMigrationData,
        searchStudentForMigrationAction,
    } = useCircular();

    const {
        getDepartmentAction,
        departmentData,
    } = useCourse();

    useEffect(() => {
        getDepartmentAction({
            department: {
                institutionId,
            },
        });
    }, []);

    useEffect(() => {
        searchStudentList()
    }, [PerPage, offset]);

    const searchStudentList = () => {
        searchStudentForMigrationAction({
            institutionId: institutionId,
            idDepartment: idDepartmentTable,
            regNumber: studentSearch,
            batchYear: idBatchTable,
            limit: PerPage,
            offset: offset,
        })
    }

    const handleTableDepartmentChange = (e) => {
        setIdDepartmentTable(e.target.value)
        getBatchByDepartmentIDAction({
            idDepartment: e.target.value,
            institutionId: institutionId,
        })
        setIdBatchTable("")
    }

    const handleSearchData = (e) => {
        searchStudentList()
        setPerPage(10);
        setOffset(0)
        setPage(1);
    }

    const count =
        searchStudentForMigrationData && Math.ceil(searchStudentForMigrationData?.totalNoOfRecord / PerPage);

    const handlePage = (e) => {
        setPerPage(e.target.value);
        setOffset(0)
        setPage(1);
    };

    const handleChangeStudent = useCallback(
        (e, p) => {
            setPage(p);
            setOffset(p * PerPage - PerPage);
        },
        [PerPage, page]
    );

    const handleDepartmentChange = (e) => {
        setIdDepartment(e.target.value)
        getBatchByDepartmentIDAction({
            idDepartment: e.target.value,
            institutionId: institutionId,
        })
        setIdBatch("");
        setIdYear("");
        setIdStudent({ studentIDS: [] });
        setStudentName([]);
    }

    const handleBatchChange = (e) => {
        setIdBatch(e.target.value)
        getStudentsByBatchAction({
            idDepartment: idDepartment,
            batchYear: e.target.value,
            institutionId: institutionId,
        })
        setIdYear("");
        setIdStudent({ studentIDS: [] });
        setStudentName([]);
    }

    const handleSelectStudentFocus = (event) => {
        const {
            target: { value },
        } = event;
        setState(
            typeof value === "string" ? value?.split(",") : value
        );
    };

    const handleSelectStudent = (event, data) => {
        if (idStudent?.studentIDS?.some((item) => item?.id == data?.id)) {
            setIdStudent({ ...idStudent, studentIDS: idStudent?.studentIDS?.filter((item) => item?.id !== data?.id) })
        } else {
            setIdStudent({ ...idStudent, studentIDS: [...idStudent?.studentIDS, { id: data?.id }] })
        }
        if (studentName?.includes(data.name)) {
            setStudentName(studentName?.filter((item) => item !== data?.name))
        } else {
            setStudentName([...studentName, data?.name])
        }
    };

    const handleStudentSelectAll = (event) => {
        if (event.target.checked) {
            let customer_names = getStudentsByBatch?.map((ele) => ele?.name)
            let selectCustomer_id = [];
            getStudentsByBatch?.map((ele) => {
                selectCustomer_id?.push({ id: ele?.id })
            })
            setStudentName(customer_names)
            setIdStudent({ studentIDS: selectCustomer_id })
        }
        else {
            setStudentName([])
            setIdStudent({ studentIDS: [] })
        }
    }

    const handleMigrationSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (studentName?.length === 0) {
            errors.studentName = "* Please select the student"
        }
        if (!idDepartment) {
            errors.idDepartment = "* Please select the departemnt"
        }
        if (!idBatch) {
            errors.idBatch = "* Please select the batch"
        }
        if (!idYear) {
            errors.idYear = "* Please select the year"
        }
        setFormErrors(errors)

        if (Object.keys(errors).length === 0) {
            updateCurrentYearAction({
                studentsList: idStudent?.studentIDS,
                currentYear: idYear,
            })
            setIdStudent({ studentIDS: [] });
            setStudentName([]);
            setIdBatch("");
            setIdYear("");
            setIdDepartment("");
        }
    }

    return (
        <>
            {loading && <Loader />}
            <Grid container className={classes.circularList}>
                <Grid item lg={8} xs={12}>
                    <Stack className={classes.align}>
                        <form onSubmit={handleMigrationSubmit}>
                            <Stack sx={{ pb: 3 }}>
                                <Typography sx={{ pb: 1 }} className={classes.input_label}>
                                    Department
                                </Typography>
                                <Select
                                    id="idDepartment"
                                    name="idDepartment"
                                    placeholder="Select Department"
                                    defaultValue="Select Department"
                                    onChange={(e) => {
                                        handleDepartmentChange(e)
                                    }}
                                    IconComponent={CustomExpandMore}
                                    value={idDepartment}
                                    displayEmpty>
                                    <MenuItem value="" disabled> Select Department </MenuItem>
                                    {departmentData &&
                                        departmentData?.map((_el, index) => (
                                            <MenuItem value={_el.id} key={index}>{_el.name}</MenuItem>
                                        ))}
                                </Select>
                                <span className={classes.error}>
                                    {formErrors.idDepartment}
                                </span>
                            </Stack>
                            <Stack sx={{ pb: 3 }}>
                                <Typography
                                    sx={{ pb: 1 }}
                                    className={classes.input_label}>
                                    Batch
                                </Typography>
                                <Select
                                    disabled={idDepartment === "" ? true : false}
                                    id="idBatch"
                                    name="idBatch"
                                    placeholder="Select Batch"
                                    IconComponent={CustomExpandMore}
                                    defaultValue="Select Batch"
                                    sx={{
                                        "& .MuiSelect-select .notranslate::after":
                                            "Select a filter"
                                                ? { content: `"Select Batch"`, opacity: 1 }
                                                : {},
                                    }}
                                    value={idBatch}
                                    onChange={(e) => {
                                        handleBatchChange(e)
                                    }}
                                    displayEmpty>
                                    <MenuItem value="" disabled>Select Batch</MenuItem>
                                    {getBatchByDepartment &&
                                        getBatchByDepartment?.map((_el, index) => (
                                            <MenuItem value={_el.batchYear} key={index}>  {_el.batchYear}   </MenuItem>
                                        ))}
                                </Select>
                                <span className={classes.error}>
                                    {formErrors.idBatch}
                                </span>
                            </Stack>
                            <Stack sx={{ pb: 3 }}>
                                <Typography sx={{ pb: 1 }} className={classes.input_label}>
                                    Student
                                </Typography>
                                <Select
                                    disabled={idBatch === "" ? true : false}
                                    id="studentName"
                                    name="studentName"
                                    multiple
                                    placeholder="Select Student"
                                    IconComponent={CustomExpandMore}
                                    defaultValue="Select Student"
                                    displayEmpty
                                    value={studentName}
                                    onFocus={handleSelectStudentFocus}
                                    renderValue={(selected) => selected?.join(', ')}
                                    sx={{
                                        "& .MuiSelect-select .notranslate::after":
                                            "Select a filter"
                                                ? { content: `"Select Student"`, opacity: 1 }
                                                : {},
                                    }}
                                >
                                    <MenuItem value="" disabled>Select Student</MenuItem>
                                    {getStudentsByBatch?.length > 1 ?
                                        <label htmlFor="studentAll">
                                            <div style={{ padding: "6px 16px", cursor: "pointer" }} onChange={(event) => handleStudentSelectAll(event)}>
                                                <Checkbox id="studentAll" checked={idStudent?.studentIDS?.length === getStudentsByBatch?.length} />Select All
                                            </div>
                                        </label> : ""}
                                    {getStudentsByBatch &&
                                        getStudentsByBatch?.map((_el, index) => (
                                            <div key={_el?.id} style={{ padding: "6px 16px", cursor: "pointer" }}
                                                onClick={(event) => handleSelectStudent(event, _el)}
                                            >
                                                <Checkbox checked={studentName?.includes(_el?.name)} />{_el?.name}
                                            </div>
                                        ))}
                                </Select>
                                <span className={classes.error}>
                                    {formErrors.studentName}
                                </span>
                            </Stack>
                            <Stack sx={{ pb: 3 }}>
                                <Typography
                                    sx={{ pb: 1 }}
                                    className={classes.input_label}>
                                    Year
                                </Typography>
                                <Select
                                    id="idYear"
                                    name="idYear"
                                    placeholder="Select Year"
                                    IconComponent={CustomExpandMore}
                                    defaultValue="Select Year"
                                    sx={{
                                        "& .MuiSelect-select .notranslate::after":
                                            "Select a filter"
                                                ? { content: `"Select Year"`, opacity: 1 }
                                                : {},
                                    }}
                                    value={idYear}
                                    onChange={(e) => {
                                        setIdYear(e.target.value);
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled> Select Year </MenuItem>
                                    {yearList && yearList?.map((_el, index) => (
                                        <MenuItem value={_el.value} key={index}>
                                            {_el.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <span className={classes.error}>
                                    {formErrors.idYear}
                                </span>
                            </Stack>
                            <Button
                                type="submit"
                                sx={{
                                    width: "100%",
                                    px: 1,
                                    py: 2,
                                    borderRadius: "50px",
                                    fontSize: "15px",
                                }}
                                className={classes.submit_btn}
                            >
                                Migrate now
                            </Button>
                        </form>
                    </Stack>
                </Grid>
                <Grid item lg={9} xs={12}>
                    <Stack sx={{ my: 4 }}>
                        <Box sx={{ width: "100%" }}>
                            <Paper sx={{
                                width: "100%",
                                borderRadius: "20px",
                                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                                boxShadow: "none",
                            }} >
                                <Stack sx={{ p: 4 }}>
                                    <Grid
                                        container
                                        sx={{ py: 1 }}
                                        className={classes.form_add_course}
                                        spacing={4}
                                    >
                                        <Grid item md={6} sx={{ width: "100%" }}>
                                            <Stack
                                                sx={{
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Stack>
                                                    <Typography
                                                        className={classes.textgap}
                                                        sx={{ pr: 1 }}
                                                    >
                                                        Department
                                                    </Typography>
                                                </Stack>
                                                <Stack>
                                                    <Select
                                                        id="idDepartment"
                                                        name="idDepartment"
                                                        placeholder="what's your favourite car?"
                                                        IconComponent={CustomExpandMore}
                                                        onChange={(e) => handleTableDepartmentChange(e)}
                                                        sx={{
                                                            width: 180,
                                                            "& .MuiSelect-select .notranslate::after":
                                                                "Select a filter"
                                                                    ? { content: `"Select Department"`, opacity: 1 }
                                                                    : {},
                                                        }}
                                                        displayEmpty
                                                        value={idDepartmentTable}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <span>Select Department</span>
                                                        </MenuItem>
                                                        {typeof departmentData !== "undefined"
                                                            ? departmentData.map((_el, index) => (
                                                                <MenuItem key={index} value={_el?.id}>
                                                                    {_el?.name}
                                                                </MenuItem>
                                                            ))
                                                            : null}
                                                    </Select>
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                        <Grid item md={6} sx={{ width: "100%" }}>
                                            <Stack
                                                sx={{
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                                gap={1}
                                            >
                                                <Stack>
                                                    <Typography
                                                        className={classes.textgap}
                                                        sx={{ pr: 5.5 }}
                                                    >
                                                        Batch
                                                    </Typography>
                                                </Stack>
                                                <Stack>
                                                    <Select
                                                        id="Batch"
                                                        name="Batch"
                                                        disabled={idDepartmentTable === "" ? true : false}
                                                        placeholder="what's your favourite car?"
                                                        IconComponent={CustomExpandMore}
                                                        sx={{
                                                            width: 180,
                                                            "& .MuiSelect-select .notranslate::after":
                                                                "Select a filter"
                                                                    ? { content: `"Select Batch"`, opacity: 1 }
                                                                    : {},
                                                        }}
                                                        displayEmpty
                                                        value={idBatchTable}
                                                        onChange={(e) => setIdBatchTable(e.target.value)}
                                                    >
                                                        <MenuItem disabled value=""><span>Select Batch</span></MenuItem>
                                                        {getBatchByDepartment &&  getBatchByDepartment?.map( (_el, index) => (
                                                           <MenuItem  value={_el?.batchYear}  key={index}>{_el?.batchYear}</MenuItem>
                                                            ))}
                                                    </Select>
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        sx={{ py: 1 }}
                                        className={classes.form_add_course}
                                        spacing={4}
                                    >
                                        <Grid item md={6} sx={{ width: "100%" }}>
                                            <Stack
                                                sx={{
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Stack>
                                                    <Typography className={classes.textgap}>
                                                        Student ID
                                                    </Typography>
                                                </Stack>
                                                <Stack>
                                                    <TextField
                                                        sx={{
                                                            width: "180px",
                                                        }}
                                                        id="regNumber"
                                                        name="regNumber"
                                                        placeholder={"Search Student"}
                                                        type={"text"}
                                                        value={studentSearch}
                                                        onChange={(e) => setStudentSearch(e.target.value)}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment
                                                                    position="start"
                                                                    sx={{ cursor: "pointer" }}
                                                                >
                                                                    <SearchIcon
                                                                        role="button"
                                                                    />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                        <Grid item md={6}>
                                            <Stack
                                                sx={{
                                                    flexDirection: "row",
                                                    justifyContent: "flex-end",
                                                }}
                                            >
                                                <Stack
                                                    sx={{
                                                        flexDirection: "row",
                                                        justifyContent: "flex-end",
                                                    }}
                                                    gap={2}
                                                >
                                                    <Button
                                                        sx={{
                                                            px: 4,
                                                            py: 1,
                                                            borderRadius: "50px",
                                                            minWidth: "150px",
                                                        }}
                                                        onClick={(e) => handleSearchData(e)}
                                                        className={classes.search_btn}
                                                    >
                                                        Search
                                                    </Button>
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                    <TableContainer id="circlarList" sx={{ maxHeight: "440px" }}>
                                        <Table aria-label="sticky table" className={classes.root} style={{ padding: 0 }} stickyHeader >
                                            <TableHead>
                                                <TableRow classes={{ root: classes.thead }}>
                                                    {columns.map((column) => (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            style={{
                                                                minWidth: column.minWidth,
                                                                paddingLeft: column.paddingLeft,
                                                            }}
                                                            classes={{ root: classes.columnData }}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody classes={{ root: classes.tBody }}>
                                                {searchStudentForMigrationData?.studentsList?.length ? (
                                                    searchStudentForMigrationData?.studentsList?.map((_el, index) => (
                                                        <TableRow
                                                            role="checkbox"
                                                            tabIndex={-1}
                                                            key={index}
                                                        >
                                                            {columns.map((column) => {
                                                                return (
                                                                    <>
                                                                        <TableCell
                                                                            key={column.id}
                                                                            align={column.align}
                                                                        >
                                                                            {column.id === "register" ? (
                                                                                _el?.regNumber
                                                                            ) : column.id === "student" ? (
                                                                                _el?.firstName + _el?.lastName
                                                                            ) : column.id === "batch" ? (
                                                                                _el?.batchYear
                                                                            ) :
                                                                                _el?.currentYear
                                                                            }
                                                                        </TableCell>
                                                                    </>
                                                                );
                                                            })}
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell
                                                            colSpan={columns?.length}
                                                            sx={{ borderBottom: "none" }}
                                                        >
                                                            <Stack
                                                                sx={{
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                No Data
                                                            </Stack>
                                                        </TableCell>
                                                    </TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    {searchStudentForMigrationData?.totalNoOfRecord > 10 && (
                                        <CustomPagination
                                            count={count}
                                            page={page}
                                            onPageChange={handleChangeStudent}
                                            handlePage={handlePage}
                                            perPage={PerPage}
                                        />
                                    )}
                                </Stack>
                            </Paper>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>
        </>
    )
}
export default Migration